import { render } from "./PublicAgencies.vue?vue&type=template&id=133e7ac5"
import script from "./PublicAgencies.vue?vue&type=script&lang=js"
export * from "./PublicAgencies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__